module.exports = __webpack_public_path__ + "img/logo.8fc2bfc1.png";